import React, { useState } from 'react';
import { uniqueId } from 'lodash';
import classnames from 'classnames';
import { Button, Spinner } from 'ui';
import InfoTooltip from 'components/shared/InfoTooltip';
import UniversalRecorderButton from 'components/ui/MediaRecorder/UniversalRecorderButton';
import UniversalAudioRecorderButton from 'components/ui/MediaRecorder/UniversalAudioRecorderButton';
import { audioFileFormats } from 'constants/mediaFileFormats';
import UniversalUploaderComponent from '../../../shared/UniversalUploader/UniversalVideoUploader';

const ActionButtons = ({
  loading,
  onRecord,
  onUpload,
  isDisabled,
  isUploading,
  recordText,
  uploadText,
  fileInput,
  fileValue,
  seismicODPScreenUploadEnabled = false,
  seismicODPWebcamUploadEnabled = false,
  seismicODPScreenRecordingEnabled = false,
  seismicODPWebcamRecordingEnabled = false,
  seismicAudioUploadEnabled = false,
  seismicAudioRecordingEnabled = false,
  saveMedia,
  isSeismic,
  isSeismicAudio,
}) => {
  const uploadId = uniqueId('upload');
  const [, setRecordingStarted] = useState(false);
  const seismicODPUploadEnabled =
    seismicODPScreenUploadEnabled || seismicODPWebcamUploadEnabled;

  const seismicODPRecordingEnabled =
    seismicODPScreenRecordingEnabled || seismicODPWebcamRecordingEnabled;

  let fileFormatsAccepted = '*/*';
  let uploadBtnText = '';
  const recordButtonText = t('questions.question.audio_recording.record');
  if (seismicODPUploadEnabled) {
    fileFormatsAccepted = '.video/quicktime, video/mp4, video/x-flv, video/*';
    uploadBtnText = t('questions.question.webcam_recording.upload');
  } else if (seismicAudioUploadEnabled) {
    fileFormatsAccepted = audioFileFormats;
    uploadBtnText = t('questions.question.audio_recording.upload');
  }

  return (
    <div className="EditorElement-actionButtons d-f fd-r">
      <div className="d-f fd-c ai-c">
        <div className="mt-24" />
        {!seismicAudioUploadEnabled && !seismicODPUploadEnabled && (
          <div className="ta-c fz-16">
            {t('common.drag_and_drop')} {t('common.or')}
          </div>
        )}
        <div className="mt-12" />
        {seismicAudioRecordingEnabled && (
          <UniversalAudioRecorderButton
            recordButtonText={recordButtonText}
            saveMedia={saveMedia}
          />
        )}
        {!seismicAudioRecordingEnabled &&
          (seismicODPRecordingEnabled ? (
            <UniversalRecorderButton
              recordButtonText={recordText}
              setRecordingStarted={setRecordingStarted}
              seismicPracticeRecordingEnabled={seismicODPRecordingEnabled}
              seismicODPRecordingEnabled={seismicODPRecordingEnabled}
              saveMedia={saveMedia}
              isSeismic={isSeismic}
            />
          ) : (
            <Button
              className={classnames({
                'mb-12': !seismicAudioUploadEnabled,
                'w-200': !seismicAudioUploadEnabled,
              })}
              primary
              loading={loading}
              onClick={onRecord}
              disabled={isDisabled || loading}
            >
              {recordText}
            </Button>
          ))}
        <div
          className={classnames(
            {
              'NewButton--loading NewButton--disabled': loading,
              'NewButton--uuc':
                seismicODPUploadEnabled || seismicAudioUploadEnabled,
              'NewButton--white':
                !seismicODPUploadEnabled && !seismicAudioUploadEnabled,
              'p-0 mt-7': seismicAudioUploadEnabled || seismicODPUploadEnabled,
            },
            'EditorElement-uploadButton NewButton NewButton--center',
          )}
        >
          {loading && <Spinner color="darker" />}
          {!loading && (
            <>
              {seismicODPUploadEnabled || seismicAudioUploadEnabled ? (
                <UniversalUploaderComponent
                  accept={fileFormatsAccepted}
                  onComplete={saveMedia}
                  uploadBtnText={uploadBtnText}
                  isSeismicAudio={isSeismicAudio}
                />
              ) : (
                <label htmlFor={uploadId}>
                  {uploadText}
                  <input
                    id={uploadId}
                    ref={fileInput}
                    type="file"
                    accept="video/quicktime, video/mp4, video/x-flv, video/*,audio/*"
                    onChange={onUpload}
                    value={fileValue}
                    disabled={loading || isUploading}
                  />
                </label>
              )}
            </>
          )}
        </div>
      </div>
      {!loading && isDisabled && (
        <InfoTooltip
          tooltip={t('questions.question.media_recording.unsupported')}
          className="ml-16"
        />
      )}
    </div>
  );
};

export default ActionButtons;
